import React, { useState } from 'react';
import './MultiSelect.css';

const MultiSelect = ({ label, options, selected = [], onChange }) => {
  const [open, setOpen] = useState(false);

  const toggle = (val) => {
    if (selected.includes(val)) {
      onChange(selected.filter(v => v !== val));
    } else {
      onChange([...selected, val]);
    }
  };

  return (
    <div className="ms-wrapper">
      <label className="ms-label">{label}</label>
      <div className="ms-trigger" onClick={() => setOpen(!open)}>
        {selected.length > 0
          ? <span className="ms-tags">{selected.join(', ')}</span>
          : <span className="ms-placeholder">Select...</span>
        }
        <span className="ms-arrow">{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div className="ms-dropdown">
          {options.map(opt => (
            <label key={opt} className="ms-option">
              <input type="checkbox" checked={selected.includes(opt)} onChange={() => toggle(opt)} />
              <span>{opt}</span>
            </label>
          ))}
          {options.length === 0 && <p className="ms-empty">No options</p>}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
